module.exports = __webpack_public_path__ + "img/Fieldkit_Panel 01_Final_signal3_sized.f4b04987.png";